import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Trophy, School, BrainCircuit, Sparkles } from "lucide-react";
import { SERVICES } from "@/data/siteContent";

const ICONS = { GraduationCap, Trophy, School, BrainCircuit, Sparkles };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-navy text-white overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]" aria-hidden>
        <div className="absolute top-10 left-10 w-96 h-96 bg-gold rounded-full blur-[180px]" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-gold rounded-full blur-[180px]" />
      </div>

      <div className="relative container-prose">
        <div className="max-w-3xl">
          <p className="eyebrow mb-5">— Our Services</p>
          <h2 className="font-serif text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Everything your child needs <span className="italic text-gold">to succeed.</span>
          </h2>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">
            From first conversations to final acceptances — a full-spectrum consultancy designed around your child's unique path.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-6 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || GraduationCap;
            // Bento: first 3 span 2 cols, last 2 span 3 cols on lg
            const span =
              i < 3 ? "lg:col-span-2" : "lg:col-span-3";
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`service-card-${i}`}
                className={`group relative p-8 md:p-10 border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] transition-all duration-500 ${span} overflow-hidden`}
              >
                <div className="absolute top-0 left-0 h-px w-0 group-hover:w-full bg-gold transition-all duration-700" />
                <div className="flex items-start justify-between gap-4 mb-6">
                  <Icon size={40} strokeWidth={1.2} className="text-gold" />
                  <span className="text-gold/40 font-serif text-xl">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif text-white text-2xl md:text-3xl mb-3 leading-tight">
                  {s.title}
                </h3>
                <p className="text-white/70 text-sm md:text-[15px] leading-relaxed">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
